import { render, staticRenderFns } from "./DamSupport.vue?vue&type=template&id=1173c574&scoped=true"
import script from "./DamSupport.vue?vue&type=script&lang=ts"
export * from "./DamSupport.vue?vue&type=script&lang=ts"
import style0 from "./DamSupport.vue?vue&type=style&index=0&id=1173c574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1173c574",
  null
  
)

export default component.exports